export default __webpack_public_path__ + "static/media/browser-not-support.28619fc5.png";